"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_ERROR_CODES = exports.ADMIN_CATALOG_ERROR_CODES = exports.DEFAULT_LOCALE = exports.SUPPORTED_LOCALES = exports.APP_NAME = void 0;
exports.isAppErrorCode = isAppErrorCode;
exports.APP_NAME = 'Cardhub';
exports.SUPPORTED_LOCALES = ['zh-CN', 'en-US'];
exports.DEFAULT_LOCALE = 'zh-CN';
exports.ADMIN_CATALOG_ERROR_CODES = [
    'REQUIRED',
    'TOO_LONG',
    'SLUG_FORMAT',
    'SLUG_TAKEN',
    'SLUG_DUPLICATE_IN_FILE',
    'IMAGE_URL',
    'INVALID_RARITY',
    'INVALID_TYPE',
    'SERIES_NOT_FOUND',
    'SERIES_HAS_CARDS',
    'CATEGORY_NOT_FOUND',
    'SUBSET_NOT_FOUND',
    'print_run_min',
    'too_big',
    'invalid_type',
    'slug_format',
    'parallel_name_required',
    'parallel_cross_series',
    'parallel_chain',
    'parallel_self',
    'parallel_has_children',
    'parallel_base_missing',
];
/** Stable codes on `error.data.appCode`. One object, shared by the API and the web. */
exports.APP_ERROR_CODES = {
    PARSE_ERROR: 'PARSE_ERROR',
    BAD_REQUEST: 'BAD_REQUEST',
    VALIDATION: 'VALIDATION',
    INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
    NOT_IMPLEMENTED: 'NOT_IMPLEMENTED',
    BAD_GATEWAY: 'BAD_GATEWAY',
    SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
    GATEWAY_TIMEOUT: 'GATEWAY_TIMEOUT',
    UNAUTHORIZED: 'UNAUTHORIZED',
    FORBIDDEN: 'FORBIDDEN',
    NOT_FOUND: 'NOT_FOUND',
    METHOD_NOT_SUPPORTED: 'METHOD_NOT_SUPPORTED',
    TIMEOUT: 'TIMEOUT',
    CONFLICT: 'CONFLICT',
    PRECONDITION_FAILED: 'PRECONDITION_FAILED',
    PAYLOAD_TOO_LARGE: 'PAYLOAD_TOO_LARGE',
    UNSUPPORTED_MEDIA_TYPE: 'UNSUPPORTED_MEDIA_TYPE',
    UNPROCESSABLE_CONTENT: 'UNPROCESSABLE_CONTENT',
    TOO_MANY_REQUESTS: 'TOO_MANY_REQUESTS',
    CLIENT_CLOSED_REQUEST: 'CLIENT_CLOSED_REQUEST',
    WRONG_PASSWORD: 'WRONG_PASSWORD',
    SAME_PASSWORD: 'SAME_PASSWORD',
    INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
    USER_BANNED: 'USER_BANNED',
    CANNOT_BAN_ADMIN: 'CANNOT_BAN_ADMIN',
    CANNOT_BAN_SELF: 'CANNOT_BAN_SELF',
    ALREADY_BANNED: 'ALREADY_BANNED',
    NOT_BANNED: 'NOT_BANNED',
    COMMENT_PARENT_GONE: 'COMMENT_PARENT_GONE',
    UNKNOWN: 'UNKNOWN',
};
const APP_ERROR_CODE_VALUES = new Set(Object.values(exports.APP_ERROR_CODES));
function isAppErrorCode(value) {
    return typeof value === 'string' && APP_ERROR_CODE_VALUES.has(value);
}
//# sourceMappingURL=index.js.map